/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsFilter } from './ContactDetailsFilter';
import {
    ContactDetailsFilterFromJSON,
    ContactDetailsFilterFromJSONTyped,
    ContactDetailsFilterToJSON,
} from './ContactDetailsFilter';

/**
 * 
 * @export
 * @interface GetAnalyticsAggregationQuestionsScoreRequestContent
 */
export interface GetAnalyticsAggregationQuestionsScoreRequestContent {
    /**
     * Return analytics on contacts created before this timestamp
     * @type {string}
     * @memberof GetAnalyticsAggregationQuestionsScoreRequestContent
     */
    from?: string;
    /**
     * Return analytics on contacts after this timestamp
     * @type {string}
     * @memberof GetAnalyticsAggregationQuestionsScoreRequestContent
     */
    to?: string;
    /**
     * 
     * @type {Array<ContactDetailsFilter>}
     * @memberof GetAnalyticsAggregationQuestionsScoreRequestContent
     */
    filters?: Array<ContactDetailsFilter>;
}


/**
 * Check if a given object implements the GetAnalyticsAggregationQuestionsScoreRequestContent interface.
 */
export function instanceOfGetAnalyticsAggregationQuestionsScoreRequestContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAnalyticsAggregationQuestionsScoreRequestContentFromJSON(json: any): GetAnalyticsAggregationQuestionsScoreRequestContent {
    return GetAnalyticsAggregationQuestionsScoreRequestContentFromJSONTyped(json, false);
}

export function GetAnalyticsAggregationQuestionsScoreRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAnalyticsAggregationQuestionsScoreRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(ContactDetailsFilterFromJSON)),
    };
}

export function GetAnalyticsAggregationQuestionsScoreRequestContentToJSON(value?: GetAnalyticsAggregationQuestionsScoreRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(ContactDetailsFilterToJSON)),
    };
}

